export const CARD_FIELDS = {
  id: { name: 'id', label: 'ID do chamado' },
  priority: { name: 'priority', label: 'Prioridade' },
  property_code: { name: 'property_code', label: 'Código do imóvel' },
  tenant_name: { name: 'tenant_name', label: 'Nome do inquilino' },
  category: { name: 'category', label: 'Categoria' },
  address: { name: 'address', label: 'Endereço' },
  created_at: { name: 'created_at', label: 'Data de abertura' },
  phone: { name: 'phone', label: 'Botão de whatsapp' },
}

export const CARD_MOCK = {
  id: '107305',
  property_code: 'IM-002',
  created_at: '2025-08-05T11:39:37.311816Z',
  priority: 1,
  phone: {
    property_owner: '999999999',
    requester: '+5547999999999',
    tradesman: '5547988888888',
  },
  category: 'Hidráulica',
  tenant_name: 'Rafael',
  address: {
    address: 'Rua Demétrio Ribeiro',
    number: '99',
    complement: 'Apto 101',
  },
}
